export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative py-24 md:py-40"
      style={{ backgroundColor: "#F7F5F0" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start">
        <div className="md:col-span-5">
          <p className="overline mb-6">02 — Philosophy</p>
          <h2 className="serif text-4xl sm:text-5xl md:text-6xl text-[#15243D] leading-[1.08] tracking-tight" style={{ fontWeight: 300 }}>
            An anchor is not <em className="italic text-[#C07865]">resistance</em>.
            <br />
            It is what lets you <em className="italic text-[#C07865]">remain</em>.
          </h2>
        </div>

        <div className="md:col-span-6 md:col-start-7 md:pt-10">
          <p className="text-lg md:text-xl font-light leading-relaxed text-[#5A5D63]">
            The waves come whether you are ready or not. What changes everything
            is what you carry within — the quiet practice of returning to
            yourself, again and again.
          </p>

          <p className="mt-6 text-base md:text-lg font-light leading-relaxed text-[#5A5D63]">
            Anchor is built on a simple idea: clarity is not found by avoiding
            life’s weather. It is cultivated through awareness, deepened in
            presence, and made real through intentional action.
          </p>

          <div className="mt-10 pt-10 border-t border-[#15243D]/10">
            <p
              className="serif text-2xl md:text-3xl leading-snug text-[#15243D] italic"
              data-testid="philosophy-quote"
              style={{ fontWeight: 300 }}
            >
              “Between stimulus and response there is a space. In that space is
              our power to choose.”
            </p>
            <p className="mt-4 text-xs tracking-[0.2em] uppercase text-[#8A8D93]">
              — Viktor E. Frankl
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
